<div>
    <h2 mat-dialog-title class="text-lg font-bold mb-1">Imagen</h2>

    <div>
        <form [formGroup]="form">
            <div class="modal-content">
                <div class="row w-full">
                    <div class="text-inside col-md-12 mb-2" style="text-align: center;">
                        <button mat-button color="warn" (click)="fileInput.click()" [disabled]="loadSave">
                            <mat-icon>file_upload</mat-icon>
                            Seleccione una imagen
                            </button>
                        <button *ngIf="this.imageUrl != null" mat-button color="warn" (click)="clearImage()" [disabled]="loadSave"
                            matTooltip="Eliminar">
                            <mat-icon>clear</mat-icon>
                        </button>
            
                        <input type="file" accept=".png,.jpg,.jpeg,.webp,.svg" name="file" #fileInput (change)="onChange(fileInput.files[0])" style="display:none;" />
                        <div *ngIf="imageUrl" style="margin: 12px;">
                            <img style="height: 150px; cursor: pointer;object-fit: contain;" [src]="imageUrl" 
                                (click)="fileInput.click()" />
                        </div>
                    </div>
                </div>
            </div>
            
            <mat-dialog-actions class="modal-actions flex">
                <button mat-button mat-dialog-close class="align-left" (click)="onClose()">Cancelar</button>
                <button mat-raised-button color="primary" (click)="onSubmit()"
                    [disabled]="!form.valid || loadSave" class="justify-end">Guardar</button>
            </mat-dialog-actions>
        </form>
    </div>
</div>